import { render, staticRenderFns } from "./QgisPluginDialog.vue?vue&type=template&id=c780c946&"
import script from "./QgisPluginDialog.vue?vue&type=script&lang=js&"
export * from "./QgisPluginDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports